import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import convertService from "../../Api/convertService";

const initialState = {
  supportedConversions: [],
  requestQuoteGuestData: [],
  requestQuoteData: [],
  executeQuoteData: [],
  convertHistoryData: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
};

export const getSupportedConversions = createAsyncThunk(
  "get/supportedConversions",
  async (_, thunkAPI) => {
    try {
      return await convertService.getSupportedConversions();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getConvertHistory = createAsyncThunk(
  "get/convertHistory",
  async (data, thunkAPI) => {
    try {
      return await convertService.ConvertHistory(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const RequestQuoteGuest = createAsyncThunk(
  "post/RequestQuoteGuest",
  async (data, thunkAPI) => {
    try {
      return await convertService.RequestQuoteGuest(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const RequestQuote = createAsyncThunk(
  "post/RequestQuote",
  async (data, thunkAPI) => {
    try {
      return await convertService.RequestQuote(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const ExecuteQuote = createAsyncThunk(
  "post/ExecuteQuote",
  async (data, thunkAPI) => {
    try {
      return await convertService.ExecuteQuote(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const convertSlice = createSlice({
  name: "convert",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportedConversions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getSupportedConversions.fulfilled, (state, action) => {
        state.supportedConversions = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getSupportedConversions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(RequestQuoteGuest.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(RequestQuoteGuest.fulfilled, (state, action) => {
        state.requestQuoteGuestData = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(RequestQuoteGuest.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(RequestQuote.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(RequestQuote.fulfilled, (state, action) => {
        state.requestQuoteData = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(RequestQuote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(ExecuteQuote.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(ExecuteQuote.fulfilled, (state, action) => {
        state.executeQuoteData = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(ExecuteQuote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getConvertHistory.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getConvertHistory.fulfilled, (state, action) => {
        state.convertHistoryData = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getConvertHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      });
  },
});

export default convertSlice.reducer;
